<template>
    <div style="line-height: 30px; margin-bottom: 10px;">
        <el-breadcrumb separator="|" style="display: inline-block;" v-if="path.length !== 1">
            <el-breadcrumb-item>
                <a @click="back">返回上一级</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item />
        </el-breadcrumb>
        <el-breadcrumb separator-class="el-icon-arrow-right" style="display: inline-block;">
            <el-breadcrumb-item :key="item.level" v-for="item in path">
                <span v-if="item.level === path.length - 1">
                    {{
                    item.labelName
                    }}
                </span>
                <a @click="changePath(item.level)" v-else>
                    {{
                    item.labelName
                    }}
                </a>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('resource');

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState({
            path: state => state.path,
        }),
    },
    methods: {
        ...mapActions(['popPath', 'clearPath']),
        back() {
            this.popPath();
        },
        changePath(level) {
            if (level === 0) {
                this.clearPath();
            } else {
                this.popPath();
            }
        },
    },
};
</script>

<style></style>
